<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">
            {{ $t('driverInfo.title') }} - {{ driverName }}
          </h1>
        </v-flex>
      </v-layout>
      <driver-form :driverId="driverId" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import DriverForm from '@/components/driver/DriverForm.vue';

export default {
  name: 'DriverInfoPage',
  components: {
    DriverForm,
  },
  data() {
    return {
      driverId: null,
    };
  },
  created() {
    const { driverId } = this.$route.params;
    this.driverId = driverId;
  },
  computed: {
    ...mapGetters({
      driverName: 'driver/getDriverName',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
